import { Button } from "reactstrap";
import styled from "styled-components";
import {
  ColorCodeInterface,
  RiskColorCode,
} from "utilFunctions/Constants/Constants";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { capitalizeWords } from "utilFunctions/helperFunctions/utilFunctions";
import { convertTime } from "utilFunctions/helperFunctions/convertTime";
import Typography from "Components/CommonComponents/Typography";
import { useContext, useEffect, useState } from "react";
import { useGetApi } from "utilFunctions/CustomHooks/useGetAPI";
import { ToastContextDispatch, UserInfoContext } from "Context/CommonContext";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import {
  BASE_URL,
  GET_LECTURE_DETAIL,
  GET_NONLECTURE_DETAIL,
} from "utilFunctions/Constants/urlConstants";
import {
  ScheduleStatus,
  AttendanceStatus,
} from "utilFunctions/shared/ScheduleStatus";
import LectureShowModalComponent from "Pages/MyBatches/MyBatch/SharedComponents/LectureShowModalComponent";
import { format, setHours, setMinutes, setSeconds, subDays } from "date-fns";
import MarkedLectureViewModal from "Pages/MySchedule/TOCModal/MarkedLectureViewModal";
import NotMarkedIcon from "Assets/Icons/NotMarkedIcon";
import EyeIcon from "Assets/Icons/EyeIcon";
import EditSmallIcon from "Assets/Icons/EditSmallIcon";
import TableLayoutAntd from "utilFunctions/shared/AntdSharedComponents/TableLayoutAntd";
import { Table, Popover as PopoverAntd } from "antd";
import { CustomMyBatchCard } from "Pages/MyBatches/MyBatch/MyBatchTabs/MyBatchStudentDetailTab";
import { useMyBatchContext } from "Pages/MyBatches/MyBatch/Context/useMyBatchContext";
import { myBatchEmitter } from "Pages/MyBatches/EmitterBus";
const SORT_ASC = "ASC";
const SORT_DESC = "DESC";
export const RiskStyledDiv = styled<any>("div")`
  background-color: ${(props: any) => props.color};
  border-radius: 4px;
  padding: 4px;
  width: fit-content;
`;
export const RiskStyledDSpan = styled<any>("span")`
  color: ${(props: any) => props.color};
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 142.857% */
`;
export const returnRiskSegment = (segment: string) => {
  const colorCode = RiskColorCode.find(
    (item: ColorCodeInterface) => item.name === segment
  );
  return (
    <RiskStyledDiv color={colorCode?.bgColor}>
      <RiskStyledDSpan color={colorCode?.color}>
        {segment == "NA" ? "Low" : segment}
      </RiskStyledDSpan>
    </RiskStyledDiv>
  );
};
function sameDay(d1: any, d2: any) {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}
export const renderingTime = (date: any) => {
  return (
    <div className="d-flex flex-row">
      {sameDay(new Date(date), new Date()) ? (
        <Typography variant="subheading3" color="black">
          {moment(date).format("D MMM YY")}&nbsp;|&nbsp;
        </Typography>
      ) : (
        <Typography variant="subheading3" color="black">
          {moment(date).format("D MMM YY")}&nbsp;|&nbsp;
        </Typography>
      )}
      <Typography variant="subheading3" color="black">
        {convertTime(date, "h:mm a")}
      </Typography>
    </div>
  );
};
const MyBatchLecturesTab = ({
  screen,
  filterState,
  setFilterState,
  dateRanges,
  selectedCourseSyllabus,
  BATCHData,
  facid,
  refresh,
}: any) => {
  const { id: batchId } = useParams();
  const [module, setModule] = useState("lecture");
  const [localFilterState, setLocalFilterState] = useState<any>(null);
  const ModuleUrl =
    module == "lecture" ? GET_LECTURE_DETAIL : GET_NONLECTURE_DETAIL;
  const { batchDetailsData } = useMyBatchContext();
  const navigate = useNavigate();
  const location = useLocation();
  const ToastDispatch = useContext(ToastContextDispatch);
  const userInfo = useContext<any>(UserInfoContext);
  const [sortOrder] = useState(
    module == "facultyLectureStatus" ? SORT_DESC : SORT_ASC
  );
  const [sortColumn] = useState<any>(
    module == "facultyLectureStatus"
      ? "scheduledStartDate"
      : module == "nonLecture"
      ? "attendanceStatus"
      : "status"
  );
  const [lectureDetail, setLectureDetail] = useState<any>([]);
  const [selectedLectureDetail, setSelectedLectureDetail] = useState<any>(null);
  const [ispaneopen, setIspaneOpen] = useState<boolean>(false);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 10,
    pageSizeOptions: ["10", "50", "100"],
    showSizeChanger: true,
    current: 1,
    sortField: "updatedAt",
    sortOrder: "DESC",
  });
  const returnBatchName = (item: any) => {
    const batchFinder = BATCHData.find((el: any) => el.batchId == item);
    return batchFinder ? batchFinder["batchName"] : "-";
  };
  const columns: any = [
    {
      title: "Lecture No.",
      dataIndex: "eventName",
      fixed: "left",
      render: (_: any, record: any) => {
        return <span>{record.eventName}</span>;
      },
    },
    {
      title: "Event Name",
      dataIndex: "eventType",
      fixed: "left",
      render: (_: any, record: any) => {
        return <span>{record.eventType}</span>;
      },
    },
    {
      title: "Date | Time",
      dataIndex: "startTime",
      render: (_: any, item: any) => {
        return (
          <div className="myScheduleHeaderStyle">
            {" "}
            {item && item.startTime && renderingTime(item.startTime)}{" "}
          </div>
        );
      },
    },
    {
      title: "Batch",
      dataIndex: "batchId",
      render: (_: any, item: any) => {
        return (
          <div>
            {BATCHData &&
            BATCHData != null &&
            item.batchId &&
            item.batchId != null
              ? returnBatchName(item.batchId)
              : "-"}{" "}
          </div>
        );
      },
    },
    {
      title: "Subject",
      dataIndex: "subject",
      render: (_: any, record: any) => {
        return <>{record.subject}</>;
      },
    },
    {
      title: "Faculty Name",
      dataIndex: "facultyName",
      render: (_: any, item: any) => {
        return (
          <>{item && item.facultyName && capitalizeWords(item?.facultyName)}</>
        );
      },
    },
    {
      title: "Syllabus Status",
      dataIndex: "status",
      width: 120,
      render: (_: any, item: any) => {
        return (
          <>
            {" "}
            <div className="cardStatusChip card-status-width d-flex flex-row justify-content-between align-items-center gap-3">
              <ScheduleStatus status={item?.status}></ScheduleStatus>
              {item["status"] != "NA" ? (
                <div className="ml-n3">
                  {item["status"] == "Unmarked" ? (
                    item["facultyId"] == userInfo.employeeId && (
                      <Button
                        outline
                        size="sm"
                        color={
                          returnDisableHandler(item)
                            ? "aeslDraft"
                            : "aeslPrimary"
                        }
                        disabled={returnDisableHandler(item)}
                        onClick={() => {
                          handleMarkSyllbus(item);
                        }}
                        className={
                          "no-hover-effect buttonHeight no-button-border"
                        }
                      >
                        {" "}
                        <NotMarkedIcon
                          color={returnDisableHandler(item) ? "#757575" : ""}
                        />
                      </Button>
                    )
                  ) : (
                    <Button
                      outline
                      size="sm"
                      color={
                        returnDisableHandler(item) ? "aeslDraft" : "aeslPrimary"
                      }
                      disabled={returnDisableHandler(item)}
                      onClick={() => {
                        setIsLectureViewModal(!isLectureViewModal);
                        setSelectedLectureDetail(item);
                      }}
                      className={
                        "no-hover-effect buttonHeight no-button-border"
                      }
                    >
                      <EyeIcon />
                    </Button>
                  )}
                </div>
              ) : null}
            </div>
          </>
        );
      },
    },
    {
      title: "Attendance",
      dataIndex: "attendance",
      width: 120,
      render: (_: any, item: any) => {
        return item?.attendanceMapStatus != undefined &&
          item?.attendanceMapStatus != null ? (
          <>
            {" "}
            <PopoverAntd
              placement="leftTop"
              content={() => (
                <>
                  {Object.keys(item?.attendanceMapStatus).map(
                    (ele: any, index: number) => (
                      <div
                        key={index}
                        className="markedLectureCountStyle d-flex flex-column justify-content-between mb-2 pr-4"
                      >
                        <div className="d-flex flex-row justify-content-between align-items-center">
                          <Typography variant="h6" color="black">
                            {ele} &nbsp;
                          </Typography>
                          <AttendanceStatus
                            status={item?.attendanceMapStatus[ele]}
                          ></AttendanceStatus>
                        </div>
                      </div>
                    )
                  )}
                </>
              )}
              title={""}
            >
              <div
                className={
                  item?.attendanceMapStatus && item?.attendanceMapStatus != null
                    ? "filterSpan"
                    : ""
                }
              >
                ALC
              </div>
            </PopoverAntd>
          </>
        ) : (
          <>
            {" "}
            <div className="cardStatusChip card-status-width d-flex flex-row justify-content-between align-items-center gap-3">
              <AttendanceStatus
                status={item.attendanceStatus}
              ></AttendanceStatus>
              {item.attendanceStatus != "NA" ? (
                <div className="ml-n3">
                  {item.attendanceStatus == "Unmarked" ||
                  item.attendanceStatus == null ? (
                    (item["facultyId"] == userInfo.employeeId ||
                      userInfo.fexRole == "Branch EDP") && (
                      <Button
                        outline
                        size="sm"
                        color={"aeslPrimary"}
                        onClick={() => {
                          handleViewLectureAttendance(item, "mark");
                        }}
                        className={
                          "no-hover-effect buttonHeight no-button-border"
                        }
                      >
                        {" "}
                        <EditSmallIcon
                          color={returnDisableHandler(item) ? "#757575" : ""}
                        />
                      </Button>
                    )
                  ) : (
                    <Button
                      outline
                      size="sm"
                      color={"aeslPrimary"}
                      disabled={returnDisableHandler(item)}
                      onClick={() => {
                        handleViewLectureAttendance(item, "edit");
                      }}
                      className={
                        "no-hover-effect buttonHeight no-button-border"
                      }
                    >
                      <EyeIcon />
                    </Button>
                  )}
                </div>
              ) : null}
            </div>
          </>
        );
      },
    },
  ];
  const toggleModal = () => {
    setIspaneOpen(!ispaneopen);
  };
  const [isLectureViewModal, setIsLectureViewModal] = useState<boolean>(false);
  const { makeRequest: GetLectureDetail, loading: lectureLoading } = useGetApi(
    (data: any) => {
      if (data && data["data"]) {
        setLectureDetail(data["data"]);
        setPagination({
          ...pagination,
          total: data.totalCount,
        });
      } else {
        setLectureDetail([]);
      }
    },
    (error: any) => {
      setLectureDetail([]);
      if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["internalCode"] &&
        error["response"]["data"]["internalCode"] != "1008"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: error.message,
        });
      } else if (
        error &&
        error["response"] &&
        error["response"]["data"] &&
        error["response"]["data"]["code"] == "NF"
      ) {
        ToastDispatch({
          isOpen: true,
          type: "Error",
          message: "No record found",
        });
      }
    }
  );
  const handler = (value: string, myBatchFilter: any) => {
    const offset = (pagination.current - 1) * pagination.pageSize;
    setModule(
      myBatchFilter && myBatchFilter.lectureType == "Non Lecture"
        ? "nonLecture"
        : "lecture"
    );
    setFilterState(myBatchFilter);
    setLocalFilterState(myBatchFilter);
    const url =
      myBatchFilter && myBatchFilter.lectureType != "Non Lecture"
        ? GET_LECTURE_DETAIL
        : GET_NONLECTURE_DETAIL;
    if (pagination.current == 1) {
      callLectureApiHandler(myBatchFilter, pagination.pageSize, offset, url);
    }
  };
  useEffect(() => {
    myBatchEmitter.on("toggleTab", handler);
    return () => {
      myBatchEmitter.off("toggleTab", handler);
    };
  }, []);
  useEffect(() => {
    if (userInfo.id) {
      const offset = (pagination.current - 1) * pagination.pageSize;
      callLectureApiHandler(
        localFilterState === null ? filterState : localFilterState,
        pagination.pageSize,
        offset,
        ModuleUrl
      );
    }
  }, [
    refresh,
    userInfo,
    pagination.current,
    pagination.pageSize,
    batchDetailsData,
  ]);
  const callLectureApiHandler = (
    filterState: any,
    limit: number,
    offset: number,
    ModuleUrl: string
  ) => {
    const sD =
      filterState && filterState.startDate
        ? filterState.startDate
        : dateRanges[0].startDate;
    const eD =
      filterState && filterState.endDate
        ? filterState.endDate
        : dateRanges[0].endDate;
    const startDate = format(
      setSeconds(setMinutes(setHours(subDays(new Date(sD), 1), 18), 30), 0),
      "yyyy-MM-dd HH:mm:ss"
    );
    const endDate = format(
      setSeconds(setMinutes(setHours(new Date(eD), 18), 30), 0),
      "yyyy-MM-dd HH:mm:ss"
    );
    const mandatoryObj = {
      empId: facid ? facid : userInfo.employeeId,
      fexRole: module == "facultyLectureStatus" ? "Faculty" : userInfo.fexRole,
      batchIds: batchId,
      startDate,
      endDate,
    };
    console.log(mandatoryObj, "facultyId", facid);
    const filterStateObj = { ...mandatoryObj, ...filterState };
    const filterLength = Object.values(filterStateObj).filter(
      (ele) => ele != null
    ).length;
    if (filterLength) {
      const obj = {
        ...mandatoryObj,
        status: filterStateObj.status,
        subject: filterStateObj.subject,
        courseId: filterStateObj.subjectList?.courseId,
        batchIds: filterStateObj.batchIds,
        attendanceStatus: filterStateObj.attendanceStatus,
        startDate: startDate,
        endDate: endDate,
      };
      console.log("obj", obj);
      if (module == "nonLecture" && filterStateObj.status) {
        obj["attendanceStatus"] = filterStateObj.status;
        delete obj["status"];
      }
      const filters2: any = [];
      const formValues: any = removeEmptyFields(obj);
      for (const key in formValues) {
        if (Object.prototype.hasOwnProperty.call(formValues, key)) {
          if (formValues[key] != null && formValues[key] != "") {
            filters2.push(
              encodeURIComponent(key) +
                "=" +
                encodeURIComponent(formValues[key])
            );
          }
        }
      }
      let url = BASE_URL + ModuleUrl;
      if (Array.isArray(filters2) && filters2.length > 0) {
        url = url + "?" + filters2.join("&");
      }
      if (
        batchDetailsData?.academicCareer == "HYB" &&
        ["SOE", "SOM"].includes(batchDetailsData?.academicGroup)
      ) {
        url =
          url +
          "&career=" +
          batchDetailsData?.academicCareer +
          "&stream=" +
          batchDetailsData?.academicGroup;
      }
      url =
        url +
        "&sortBy=" +
        sortColumn +
        "&sortDir=" +
        sortOrder +
        `&limit=${limit}&offset=${offset}`;
      GetLectureDetail(url);
    }
  };
  function sameDay(d1: any, d2: any) {
    return (
      d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate()
    );
  }
  const renderingTime = (date: any) => {
    return (
      <div className="d-flex flex-row">
        {sameDay(new Date(date), new Date()) ? (
          <Typography variant="h6" color="black">
            {moment(date).format("D MMM YY")}&nbsp;|&nbsp;
          </Typography>
        ) : (
          <Typography variant="subheading3" color="black">
            {moment(date).format("D MMM YY")}&nbsp;|&nbsp;
          </Typography>
        )}
        <Typography variant="subheading3" color="black">
          {convertTime(date, "h:mm a")}
        </Typography>
      </div>
    );
  };
  const handleViewLectureAttendance = (item: any, type: any) => {
    const batchName =
      module != "facultyLectureStatus"
        ? batchDetailsData != null && batchDetailsData.batchName
        : item.batchName;
    navigate("/admin/schedule/attendance/" + item.batchTimeTableId, {
      replace: false,
      state: {
        selectedSchedule: {
          ...item,
          batchName: batchName,
          branchId: item.branchCode ?? batchDetailsData?.businessArea,
        },
        faculty: {
          ...item,
        },
        selectedBatch:
          location.state &&
          location.state != null &&
          location?.state?.selectedBatch != null
            ? location.state.selectedBatch
            : null,
        attendanceStatus: type,
        referrer: location.pathname,
        myBatchRedirectTab: 2,
        selectedDefaultTab: "4",
        myBatchRedirectSelect:
          module == "nonLecture" ? "Non Lecture" : "Lectures",
        selectedRegion:
          location.state &&
          location.state != null &&
          location?.state?.selectedRegion != null
            ? location.state.selectedRegion
            : null,
        courseId: item?.courseId,
        myBatchAcademicCareer: batchDetailsData?.academicCareer,
        myBatchAcademicGroup: batchDetailsData?.academicGroup,
      },
    });
  };
  const handleMarkSyllbus = (cardViewData: any) => {
    console.log("batchDetailsData", cardViewData, batchDetailsData);
    navigate("/admin/schedule", {
      replace: false,
      state: {
        isTodaySchedule: true,
        faculty: {
          ...cardViewData,
          batchName: batchDetailsData?.batchName,
        },
        selectedBatch: location.state.selectedBatch,
        dateRanges: dateRanges,
        batchDetail: {
          ...cardViewData,
          batchName: batchDetailsData?.batchName,
        },
        referrer: location.pathname,
        myBatchRedirectTab: 2,
        selectedDefaultTab: "4",
        myBatchRedirectSelect: "Lectures",
        myBatchAcademicCareer: batchDetailsData?.academicCareer,
        myBatchAcademicGroup: batchDetailsData?.academicGroup,
      },
    });
    //localStorage.setItem("myBatchRedirectTab", "2");
  };
  const returnDisableHandler = (cardViewData: any) => {
    if (cardViewData.syllabusList) {
      return false;
    } else {
      if (cardViewData.eventLink) {
        return false;
      }
      return false;
    }
  };
  const obj = {
    batchId: batchId,
    courseId: selectedCourseSyllabus?.courseId,
  };
  const editHandler = () => {
    console.log("");
  };
  const handleTableChange = (paginations: any, filters: any, sorter: any) => {
    const sortField = sorter.columnKey || pagination.sortField;
    let sortOrder = pagination.sortOrder;
    if (sorter.order !== undefined) {
      sortOrder = sorter.order === "descend" ? "DESC" : "ASC";
    }
    setPagination({
      ...paginations,
      sortField,
      sortOrder: sortOrder,
    });
  };
  return (
    <CustomMyBatchCard screen={screen}>
      {selectedLectureDetail != null && (
        <MarkedLectureViewModal
          mode="myBatchLecture"
          selectedlecture={selectedLectureDetail}
          isLectureViewModal={isLectureViewModal}
          setIsLectureViewModal={setIsLectureViewModal}
          editHandler={editHandler}
        ></MarkedLectureViewModal>
      )}
      <LectureShowModalComponent
        batchDetailsData={batchDetailsData}
        selectedlecture={obj}
        selectedLectureDetail={selectedLectureDetail}
        ispaneopen={ispaneopen}
        toggleModal={toggleModal}
      ></LectureShowModalComponent>
      <TableLayoutAntd isLoader={lectureLoading}>
        <Table
          className="antdTablePagination"
          scroll={{ x: "max-content" }}
          bordered
          size="small"
          columns={
            module == "facultyLectureStatus"
              ? columns.filter(
                  (el: any) =>
                    !["eventType", "facultyName"].includes(el.dataIndex)
                )
              : module == "nonLecture"
              ? columns.filter(
                  (el: any) =>
                    !["status", "subject", "batchId", "eventName"].includes(
                      el.dataIndex
                    )
                )
              : columns.filter(
                  (el: any) => !["eventType", "batchId"].includes(el.dataIndex)
                )
          }
          dataSource={lectureDetail}
          onChange={handleTableChange}
          pagination={pagination}
        />
      </TableLayoutAntd>
    </CustomMyBatchCard>
  );
};

export default MyBatchLecturesTab;
